export default __webpack_public_path__ + "static/media4-de41eef114f929168ae148ffceaa7026.jpg";